import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import ReduxContacts from "../../../../store/actionreducers/apply_medical/contacts";
import {FusePageSimple} from '../../../../@fuse/index';
import ContactsList from './ApplyMedicalList';
import ContactsHeader from './ApplyMedicalHeader';
import ContactDialog from './ApplyMedicalDialog';
import AlertDialog from './AlertDialog';

const headerHeight = 160;

const styles = theme => ({
    root: {},
    avatar: {},
    layoutHeader: {
        height: headerHeight,
        minHeight: headerHeight
    },
    layoutContentCardWrapper: {
        padding: 24,
        paddingBottom: 80
    },
    layoutLeftSidebar: {
        width: 246
    },
    addButton: {
        position: 'absolute',
        right: 12,
        bottom: 12,
        zIndex: 99
    }
});

class TrialVipsApp extends Component {

    componentDidMount() {
        this.props.getContacts(this.props.match.params);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(this.props.location, prevProps.location)) {
            this.props.getContacts(this.props.match.params);
        }
    }

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <ContactsHeader pageLayout={() => this.pageLayout}/>
                    }
                    content={
                        <ContactsList/>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />
                <ContactDialog/>
                <AlertDialog/>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addContact: ReduxContacts.ActionCreator.validateMedical,
        getContacts: ReduxContacts.ActionCreator.getContacts,
    }, dispatch);
}

function mapStateToProps({applyMedicalsApp}) {
    return {
        contacts: applyMedicalsApp.contacts.entities,
        selectedContactIds: applyMedicalsApp.contacts.selectedContactIds,
        searchText: applyMedicalsApp.contacts.searchText,
        user: applyMedicalsApp.user
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(TrialVipsApp)));



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/medical/ApplyMedicalsApp.js